export default __webpack_public_path__ + "static/softclipper-gui-947e09cbd9c72e2717beedfa6176ab07.png";